import { BordEmptyState } from 'bord-design-system';
import { EQuoteStatus } from 'types/quote.types';

import './EmptyStateByQuoteStatus.scss';

type TBordEmptyStateProps = Parameters<typeof BordEmptyState>[0];

type TIlustrationProps = TBordEmptyStateProps['ilustrationIconProps'];

interface IEmptyStateByQuoteStatus {
  quoteStatus: EQuoteStatus;
  noResults?: boolean;
}

const configByQuoteStatus: Record<EQuoteStatus, { title: string; subtitle: string; ilustration: TIlustrationProps }> = {
  EXPIRED: {
    title: '¡Sin cotizaciones vencidas!',
    subtitle: 'No hay cotizaciones vencidas en los últimos 7 días. ',
    ilustration: {
      variant: 'filledSuccess'
    }
  },
  PENDING_APPROVAL: {
    title: 'Sin cotizaciones esperando respuesta',
    subtitle:
      'Actualmente no hay cotizaciones enviadas a clientes. Cuando envíes una cotización, aparecerá aquí para dar seguimiento.',

    ilustration: { variant: '3DSpecialDocument' }
  },
  PURCHASED: {
    title: 'Aún no hay compras',
    subtitle: 'Las cotizaciones que los clientes conviertan en órdenes de compra aparecerán aquí.',
    ilustration: {
      variant: '3DSpecial'
    }
  },
  TO_QUOTE: {
    title: '¡Todo cotizado!',
    subtitle:
      'No hay cotizaciones pendientes por cotizar en este momento. Las nuevas solicitudes aparecerán aquí automáticamente.',
    ilustration: {
      variant: 'filledSuccess'
    }
  },
  REJECTED: {
    title: 'Sin cotizaciones canceladas',
    subtitle: 'No se han cancelado cotizaciones en los últimos 7 días.',
    ilustration: {
      variant: 'filledSuccess'
    }
  }
};

export const EmptyStateByQuoteStatus = ({ quoteStatus, noResults }: IEmptyStateByQuoteStatus) => {
  return (
    <div className="emptyStateByQuoteStatus">
      {noResults ? (
        <BordEmptyState
          ilustrationIconProps={{ variant: 'search', standardSize: 100 }}
          title="No hay resultados para tu búsqueda"
          subTitle="Intenta probando con otros criterios de búsqueda "
        />
      ) : (
        <BordEmptyState
          ilustrationIconProps={{ variant: configByQuoteStatus[quoteStatus]?.ilustration?.variant!, standardSize: 100 }}
          title={configByQuoteStatus[quoteStatus]?.title}
          subTitle={configByQuoteStatus[quoteStatus]?.subtitle}
        />
      )}
    </div>
  );
};
